// extracted by mini-css-extract-plugin
export default {"time_label":"time-label_time_label__NZJ5o"};